(function($) {

	$.fn.CORE_datepicker = $.fn.datepicker;
	$.fn.datepicker = function(opts)
	{
		// smart defaults.
		var defaults = {
			todayHighlight: true,
			toggleActive: true,
			autoclose: true
		};
		var mixedOpts = $.extend({}, defaults, opts, $(this).data());

		$(this).CORE_datepicker(mixedOpts);
	};

	$('.dropdown.hover').hover(function() {
		$(this).find("> .dropdown-menu").show();
	}, function() {
		$(this).find("> .dropdown-menu").hide();
	});

	$(document).ready(function() {

		$('.dropdown.toggle > a').click(function() {
			var menu = $(this).parent().find("> .dropdown-menu");
			var navbar = $(this).closest('.navbar'); //  Only close other navs in same bar.
			if(menu.is(":visible"))
			{
				menu.hide();
			} else {
				$(navbar).find('.dropdown-menu').hide();
				menu.show();
			}
		});
		/* DO NOT hide dropdown menu if click elsewhere on screen 
		$(document).on('click', function(e) { 
			if(!$(e.target).closest('.dropdown.toggle').size() && $('.dropdown.toggle .dropdown-menu:visible').size()) // clicked outside of open dropdown menu 
			{ // need to ensure that not inside dropdown, so initial show() works
				$('.dropdown.toggle .dropdown-menu:visible').hide();
				
			}
		});
		*/

		$('.autogrow').each(function() {
			$(this).autogrow();
		});

		$('a.lightbox').each(function() {
			$(this).lightBox();
		});

		setTimeout(function() { 
			$('#navbar .navbar-nav.autofit').each(function() {
				$(this).autofit_nav();
			});
		}, 500);
		// standardize datepicking
		$('.datepicker').datepicker();

		// Turn into modal alerts. - if $this->assign('flash_class','modal_flash') in view
		$('.flash_message.flash_modal, .flash_message.modal_flash').each(function() {
			var message = $(this).detach();

			var details = {
				message: message.html()
			};
			if(message.hasClass('alert-info'))
			{
				details.title = 'Notice';
				details.type = BootstrapDialog.TYPE_INFO;
			} else if (message.hasClass('alert-danger')) { 
				details.title = 'Error';
				details.type = BootstrapDialog.TYPE_DANGER;
			} else if (message.hasClass('alert-warning')) { 
				details.title = 'Warning';
				details.type = BootstrapDialog.TYPE_WARNING;
			} else if (message.hasClass('alert-success')) { 
				details.title = 'Success';
				details.type = BootstrapDialog.TYPE_SUCCESS;
			} else {
				details.title = 'Notice';
				details.type = BootstrapDialog.TYPE_PRIMARY;
			}
			BootstrapDialog.alert(details);
		});
	});
	$(window).resize(function() {
		$('#navbar .navbar-nav.autofit').each(function() {
			$(this).autofit_nav();
		});
	});


        $.loading = function() { // call multiple times to toggle.
        	if(dialog = $.getDialog('loading'))
        	{
				dialog.close();
				// dialog.destroy() ???
        	} else {
                BootstrapDialog.show({
                		id: 'loading',
                        onshow: function(dialog) {
                                dialog.getModalHeader().hide();
                        },
                        message:"<div class='center_align padding10'><h1>Loading...</h1><div class='progress'><div class='width100p progress-bar progress-bar-striped active'></div></div></div>"
                });
            }
        };

})(jQuery);
